/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/GetStringBetween.ts
 * @create:      2025-06-26 13:02:49.134
 * @modify:      2025-07-11 21:19:12.853
 * @version:     6.0.0
 * @times:       6
 * @lines:       52
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { GetStringPositionBetween } from "./GetStringPositionBetween";

/**
 * Extracts all substrings from the input string that are found between the specified start and end delimiters.
 *
 * @param str - The input string to search within.
 * @param start - The starting delimiter string.
 * @param end - The ending delimiter string.
 * @param max - The maximum number of substrings to extract. If set to -1, all matches are returned.
 * @returns An array of substrings found between the specified start and end delimiters.
 * 
 * @version 2018-09-01
 * @since 1.0.6
 */
export function GetStringBetween(str: string, start: string, end: string, max = -1) {
    return GetStringPositionBetween(str, start, end, max).map(
        p => str.substring(p.Start, p.End),
    );
}
